import React, { useState, createContext, useContext } from 'react';
import Callback from '../../Services/Callback';

const ModalContext = createContext();

const useModalContext = () => {
    return useContext(ModalContext);
};

const Provider = ({ children }) => {
    const closer = new Callback();
    const [isDismissingPrevented, setIsDismissingPrevented] = useState(null);

    const providerValues = {
        closeModal: () => closer.invoke(),
        closer,
        preventDismissing: (val) => setIsDismissingPrevented(val),
        isDismissingPrevented,
    }

    return (
        <ModalContext.Provider value={providerValues}>
            {children}
        </ModalContext.Provider>
    );
};

export {
    useModalContext,
    Provider,
}
